import React from 'react';

const defaultContext = Object.freeze({});
export const PrayerDetailContext = React.createContext(defaultContext);
